import { Flex } from 'foundations-components/components/Flex';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { AgentStatusWorkingHoursPrompt } from '../../prompts/components/AgentStatusWorkingHoursPrompt';
import { getAwayMode } from '../operators/getters';
import { getStatusMessage } from '../utils/agentStatusUtils';
import AvailabilityIndicator from './AvailabilityIndicator';
import { OutOfOfficeLabel } from './StatusMessage/OutOfOfficeLabel';
import { WorkingHoursToggleTooltip } from './WorkingHoursToggleTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentStatusToggle = ({
  agentStatus,
  updateAwayMode,
  atCapacity,
  userId,
  currentSegment
}) => {
  const isAwayMode = Boolean(getAwayMode(agentStatus));
  const onAwayModeToggle = () => {
    const nextAwayModeState = !getAwayMode(agentStatus);
    updateAwayMode(nextAwayModeState);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "row",
    inlineSize: "100%",
    justifyContent: "space-between",
    paddingInlineStart: "200",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
          isAwayMode: isAwayMode,
          atCapacity: atCapacity
        }), getStatusMessage(isAwayMode)]
      }), currentSegment && /*#__PURE__*/_jsx(OutOfOfficeLabel, {
        userId: userId,
        currentSegment: currentSegment
      })]
    }), /*#__PURE__*/_jsx(AgentStatusWorkingHoursPrompt, {
      userId: userId,
      isAway: isAwayMode,
      children: /*#__PURE__*/_jsx(WorkingHoursToggleTooltip, {
        userId: userId,
        children: /*#__PURE__*/_jsx(Toggle, {
          checked: !isAwayMode,
          "data-test-id": "agent-status-toggle",
          size: "extra-small",
          onChange: onAwayModeToggle,
          marginInlineStart: "200"
        })
      })
    })]
  });
};
AgentStatusToggle.displayName = 'AgentStatusToggle';
export default AgentStatusToggle;